import React, {Component} from 'react';
import {Card, Table} from 'semantic-ui-react';
import _ from 'lodash';
import {getNumericValue} from '../../../../../common/util/fieldsValidation';
import {getMonthName} from '../../../../../common/util/date';
import './table.scss';

class SalesByAgenciesList extends Component {
  getFormattedData() {
    const {data} = this.props;
    const salesByAgencies = data && data.dealerSales ? data.dealerSales : [];

    const titles = [];
    const dataByAgency = [];
    let totalsByMonth = [];

    salesByAgencies.forEach((agency, index) => {
      const values = [];
      agency.sales.forEach((sale) => {
        if (index === 0) {
          titles.push({'month': sale.month});
        }

        values.push({'amount': sale.amount});
        totalsByMonth = this.sumTotalsByMonth(totalsByMonth, sale);
      });
      dataByAgency.push({
        'agencyName': agency.agencyName,
        values,
        'totalByAgency': agency.total,
      });
    });

    const dataFormatted = {
      titles,
      dataByAgency,
      totalsByMonth,
    };
    return dataFormatted;
  }

  sumTotalsByMonth(list, saleData) {
    const index = _.findIndex(list, {'month': saleData.month});
    if (index === -1) {
      list.push({'month': saleData.month, 'amount': saleData.amount});
      return list;
    }

    const total = list[index].amount + saleData.amount;
    list[index].amount = total;
    return list;
  }

  renderTitleByColumn(list) {
    return list.map((element, index) => {
      return (
        <Table.HeaderCell key={index} textAlign='center'>
          {getMonthName(element.month)}
        </Table.HeaderCell>
      );
    });
  }

  renderRowInfo(list) {
    return list.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='left'>{element.agencyName}</Table.Cell>
          {this.renderDataByMonth(element.values, '')}
          <Table.Cell textAlign='right' className='totals-column'>
            {'$'}
            {getNumericValue(element.totalByAgency, 2)}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderDataByMonth(list, className) {
    return list.map((element, index) => {
      const value = element.amount ?
        `$${getNumericValue(element.amount, 2)}` :
        '';
      return (
        <Table.Cell key={index} textAlign='right' className={className}>
          {value}
        </Table.Cell>
      );
    });
  }

  renderTotalsByMonth(list) {
    const {data} = this.props;
    return (
      <Table.Row className='totals-row'>
        <Table.Cell textAlign='left'>TOTAL</Table.Cell>
        {this.renderDataByMonth(list, 'total')}
        <Table.Cell textAlign='right'>
          {'$'}
          {getNumericValue(data.total, 2)}
        </Table.Cell>
      </Table.Row>
    );
  }

  renderInfo() {
    const dataFormatted = this.getFormattedData();
    return (
      <div className='table-container'>
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>
                AGENCIAS \ MESES
              </Table.HeaderCell>
              {this.renderTitleByColumn(dataFormatted.titles)}
              <Table.HeaderCell textAlign='center' className='totals-column'>
                TOTAL
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {this.renderRowInfo(dataFormatted.dataByAgency)}
            {this.renderTotalsByMonth(dataFormatted.totalsByMonth)}
          </Table.Body>
        </Table>
      </div>
    );
  }

  render() {
    return (
      <Card fluid raised className='sales-by-agencies'>
        {this.renderInfo()}
      </Card>
    );
  }
}

export default SalesByAgenciesList;
